import { TemplateRef } from "@angular/core";
import { CellEditor } from "./editor.type";

export interface ColumnFormatter {
    type?: 'datetime' | 'number' | 'enum' | 'image' | 'boolean' | 'boolean2' | 'timeago';
    options?: any;
}

type ColumnFormatterFn = (column, rowData, otherCtx) => any;
/**
 * 附件展示列信息
 * formatter：格式化
 */
export interface ColumnData{
    field:string;
    width:number;
    title:string;
    checkbox?:boolean;
    formatter?:ColumnFormatterFn| ColumnFormatterFn;
    template?:TemplateRef<any>;
    editor?:CellEditor,
    editorTemplate?:TemplateRef<any>;
    minWidth?:number;
}

